/*
 * Casa Mora - send every cart "Checkout" button to the confirm-address page first.
 * Theme-agnostic: in Dwell both the cart page (snippets/cart-summary.liquid) and the Shine Pages
 * cart drawer (snippets/shine-pages-cart-drawer.liquid) use <button name="checkout" type="submit">
 * posting a form to /cart, so one capture-phase listener catches both.
 *
 * Product-page "Buy it now" (Shopify's dynamic checkout button) is caught too: the product is added
 * to the cart instead, then the shopper goes to the confirm-address page like every other checkout.
 * Anything that still reaches checkout without the page gets tagged needs-address by the backend.
 */
(function () {
  'use strict';
  var script = document.currentScript;
  var confirmPath = (script && script.getAttribute('data-confirm-path')) || '/pages/confirm-address';
  var SELECTOR = 'button[name="checkout"], input[type="submit"][name="checkout"], a[href="/checkout"], a[href^="/checkout?"]';

  function onConfirmPage() {
    return window.location.pathname.replace(/\/+$/, '') === confirmPath.replace(/\/+$/, '');
  }

  // A drawer cart note typed but not yet saved would be lost by skipping the form post, so save it first.
  function saveNoteThen(form, go) {
    var note = form && form.querySelector('[name="note"]');
    if (!note) return go();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).then(go, go);
  }

  function redirect(e, trigger) {
    if (onConfirmPage()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = trigger.form || trigger.closest('form');
    saveNoteThen(form, function () { window.location.href = confirmPath; });
  }

  // "Buy it now": add this product (variant, quantity, line item properties) to the cart, then confirm.
  var BUY_NOW = '.shopify-payment-button__button, shopify-buy-it-now-button, shopify-accelerated-checkout';
  var buying = false;
  function buyNow(e, trigger) {
    var form = trigger.closest('form[action*="/cart/add"]');
    if (!form) return; // unknown layout: leave Shopify's button alone (backend still tags needs-address)
    e.preventDefault();
    e.stopImmediatePropagation();
    if (buying) return;
    if (form.reportValidity && !form.reportValidity()) return;
    buying = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error((j && (j.description || j.message)) || 'HTTP ' + r.status);
        });
      })
      .then(function () { window.location.href = confirmPath; })
      .catch(function (err) { buying = false; window.alert(err.message); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var buy = e.target.closest(BUY_NOW);
    if (buy && !buy.disabled) return buyNow(e, buy);
    var trigger = e.target.closest(SELECTOR);
    if (trigger && !trigger.disabled) redirect(e, trigger);
  }, true);

  // Enter-key submits and programmatic requestSubmit() of a checkout form.
  document.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') redirect(e, submitter);
  }, true);
})();
